module.exports = __webpack_public_path__ + "static/media/track-sea-of-heart-break.b816263e.png";